module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_4.1b64bfef.png";